import * as Axios from 'axios';
import BaseService from '@/services/common/BaseService';
import store from '@/store';
import { IQuestion, IQuestionCategory, IQuestionEvent } from '@/domain/suppliers';

export default class QuestionService extends BaseService {

    public async getAllLibraryQuestions(params?: { fromDate?: string; tags?: string; categories?: string }): Promise<IQuestion[]> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/suppliers/library/questions`,
            params,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig);
        return res.data as IQuestion[];
    }

    public async getLibraryQuestion(questionId: string): Promise<IQuestion> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/suppliers/library/questions/${questionId}`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig);
        return res.data as IQuestion;
    }

    public async createLibraryQuestion(question: IQuestion): Promise<IQuestion> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'post',
            url: `${store.state.apiBase}/suppliers/library/questions`,
            data: { question },
            headers: {
                Authorization: `Bearer ${store.state.$auth.token}`,
                'Content-Type': 'application/json'
            }
        }

        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig);
        return res.data as IQuestion;
    }

    public async updateLibraryQuestionWip(questionId: string, question: IQuestion): Promise<void> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'put',
            url: `${store.state.apiBase}/suppliers/library/questions/${questionId}/wip`,
            data: { question },
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        await this.makeAxiosCall(apiConfig);
    }

    public async publishLibraryQuestion(questionId: string): Promise<void> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'post',
            url: `${store.state.apiBase}/suppliers/library/questions/${questionId}/publish`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        await this.makeAxiosCall(apiConfig);
    }

    public async getQuestionHistory(questionId: string): Promise<IQuestionEvent[]> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/suppliers/library/questions/${questionId}/history`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig);
        return res.data as IQuestionEvent[];
    }

    public async restoreQuestionVersion(questionId: string, eventId: string): Promise<void> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'post',
            url: `${store.state.apiBase}/suppliers/library/questions/${questionId}/restore`,
            data: { eventId },
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        await this.makeAxiosCall(apiConfig);
    }

    public async deleteLibraryQuestion(questionId: string): Promise<void> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'delete',
            url: `${store.state.apiBase}/suppliers/library/questions/${questionId}`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        await this.makeAxiosCall(apiConfig);
    }

    public async getQuestionTags(): Promise<string[]> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/suppliers/library/questions/tags`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig);
        return res.data as string[];
    }

    public async getQuestionCategories(): Promise<IQuestionCategory[]> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/suppliers/library/questions/categories`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig);
        return res.data as IQuestionCategory[];
    }

    public async updateQuestionCategories(categories: IQuestionCategory[]): Promise<void> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'put',
            url: `${store.state.apiBase}/suppliers/library/questions/categories`,
            data: { categories },
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        await this.makeAxiosCall(apiConfig);
    }
}
